import { render, staticRenderFns } from "./AtopicDermatitisSymptomsPhase.vue?vue&type=template&id=b7233610&"
import script from "./AtopicDermatitisSymptomsPhase.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisSymptomsPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports